import React, { useEffect, useState, useContext } from "react";
import { Table, Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getAuthToken } from "../../util/auth";
import { getApiChara } from "../../util/getApi";
import WaitingContext from "../../store/waitingListContext";
import { toast } from "react-toastify";
import AuthContext from "../../store/auth-context";
import { useTranslation } from "react-i18next";

const PatientModal = ({ patientData, OnCloseModalBlock, checkUpData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const chechUpContext = useContext(WaitingContext);
  const authCtx = useContext(AuthContext);
  const [doctorData, setDoctorData] = useState({});

  useEffect(() => {
    fetchDoctorDetails();
  }, []);

  const fetchDoctorDetails = async () => {
    const userId = authCtx.userId;
    const token = getAuthToken();
    if (!token || token === "EXPIRED") {
      navigate("/");
      return;
    }
    try {
      const apiChar = getApiChara();
      const apiUrl = `${apiChar}/users/${userId}`;
      const response = await fetch(apiUrl, {
        headers: { Authorization: "Bearer " + token },
      });
      if (!response.ok) {
        console.error("Doctor data not fetched");
        return;
      }
      const data = await response.json();
      setDoctorData(data);
    } catch (err) {
      console.error("Error fetching doctor data:", err);
    }
  };

  // ✅ Select patient handler with duplicate check
  const getSelectedPatientFromList = (patient) => {
    if (!patient) return;

    // --- check if this patient already exists in today's checkup list ---
    const alreadyExists = checkUpData?.some(
      (p) => p?.patientId?.patientId === patient?.patientId
    );

    if (alreadyExists) {
      toast.warning(t("This patient is already available in today's checkup list!"));
      return; // stop here — no navigation
    }

    // --- if not exists, continue normal flow ---
    const checkUpPatient = {
      patientId: patient,
      doctorId: doctorData,
    };

    chechUpContext.OnAddedcheckUp(checkUpPatient);
    OnCloseModalBlock(); // close modal
    navigate("checkpatient");
  };

  return (
    <Modal
      show={patientData?.length > 0}
      onHide={OnCloseModalBlock}
      centered
      size="lg"
      className="patientModel"
    >
      <Modal.Header
        closeButton
        style={{
          backgroundColor: "var(--primary-color)",
          color: "white",
          border: "1px solid var(--primary-color)",
        }}
      >
        <Modal.Title className="w-100 text-center">{t("Select Patient")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>{t("Patient Id")}</th>
              <th>{t("Name")}</th>
              <th>{t("Mobile")}</th>
              <th>{t("Actions")}</th>
            </tr>
          </thead>
          <tbody>
            {patientData?.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center">
                  {t("No Record found")}
                </td>
              </tr>
            )}
            {patientData?.map((p) => (
              <tr key={p.patientId}>
                <td>{p.patientId}</td>
                <td>
                  {`${p.firstName || ""} ${p.middleName ? p.middleName + " " : ""
                    }${p.lastName || ""}`.trim()}
                </td>
                <td>{p.mobile || "-"}</td>
                <td>
                  <Button
                    size="sm"
                    className="btn button-sm"
                    onClick={() => getSelectedPatientFromList(p)}
                  >
                    {t("Select")}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
};

export default PatientModal;
